<template>
  <div class="empty-block">
    <img
      :src="src"
      alt="pic"
      class="empty-block__icon"
    />

    <div class="empty-block__title">
      <UiText
        class="empty-block__text"
        color="typography-title01"
        font="hero-display-5"
        :text="desk"
      />
      <UiText
        class="empty-block__text"
        color="typography-title01"
        font="hero-display-5"
        :text="desk2"
      />
    </div>
    <UiText
      class="empty-block__text"
      color="typography-body01"
      font="body-text-small"
    >
      <div v-html="text" />
    </UiText>

    <UiBtn
      v-if="term"
      :to="term"
      color="primary"
      class="empty-block__btn"
      :text="btnText"
    />
  </div>
</template>

<script>
export default {
  name: 'MissingGames',
  props: {
    src: { type: String },
    desk: { type: String },
    desk2: { type: String },
    text: { type: String },
    term: { type: String },
    btnText: { type: String },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
